export default class LoadUserAdmin {
  constructor(context) {
    this.context = context;
  }

  run() {
    if (this.context.stores.appFeatures.get().isEnabled('teamManagement')) {
      this.context.gateways.agentProfile.requestAll();
      this.context.gateways.user.request();
      this.context.stores.agentProfiles.setLoading();
      this.context.stores.users.setLoading();
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/users/load_user_admin.js